import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Select from '../../../../../components/input/Select';
import CountOfTotal from '../../../../../components/CountOfTotal';
import DateSinglePicker from '../../../../../components/datePicker/DateSinglePicker';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_ITEM_DELAY_REASON_TYPE_SELECT_LIST,
  DELIVERY_DELAY_DATE_FORMAT,
  MAXIMUM_DAY_OF_DELIVERY_DELAY_DAYS,
  MAXIMUM_NUMBER_OF_DELIVERY_DELAY_REASON_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import moment from '../../../../../lib/moment';

const DeliveryDelayModal = (props) => {
  const { isOpen, form, onSubmit, setData, closeModal, reasonType, date, reason } = props;

  return (
    <Modal
      title="배송 지연 안내"
      isOpen={isOpen}
      width={670}
      height={400}
      isFooter={true}
      okText={'배송 지연'}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="delivery-delay-modal-wrap">
        <div className="delivery-delay-info">
          <div>* 결제일로부터 3영업일 이내에 발송처리가 불가한 경우, '배송지연 안내'처리를 하셔야 합니다.</div>
          <div>* 배송지연 안내 처리는 1회만 가능하며, 입력하신 지연사유는 구매자에게 안내가 됩니다.</div>
          <div>* 발송기한 경과시까지 발송처리가 되지 않으면 구매자 취소요청시 즉시 환불처리가 진행됩니다.</div>
        </div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">배송 지연 사유</td>
              <td className="tl" colSpan={3}>
                <Select
                  list={ORDER_ITEM_DELAY_REASON_TYPE_SELECT_LIST}
                  onChange={(id) =>
                    setData({
                      name: 'reasonType',
                      value: id,
                    })
                  }
                  value={reasonType}
                  size="default"
                  isTable={true}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">발송기한</td>
              <td className="tl" colSpan={3}>
                <DateSinglePicker
                  value={date}
                  outFormat={DELIVERY_DELAY_DATE_FORMAT}
                  format={DATE_FORMAT.YMD_DASH_FORMAT}
                  disabledDate={(day) =>
                    day.isAfter(moment().add(MAXIMUM_DAY_OF_DELIVERY_DELAY_DAYS, 'days')) || day.isBefore(moment())
                  }
                  onSelect={(date) =>
                    setData({
                      name: 'date',
                      value: date,
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>배송 지연 상세 사유</span>
                <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_DELIVERY_DELAY_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="reason"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={reason}
                  onChange={(value) =>
                    setData({
                      name: 'reason',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_DELIVERY_DELAY_REASON_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="delivery-delay-info">
          <div className="caution">* 입력하신 내용은 처리 후 수정이 불가합니다. 발송기한을 정확하게 입력해 주세요.</div>
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryDelayModal;
